module.exports = __webpack_public_path__ + "img/Texas Outline.63125d57.png";